import React from 'react';
import { Spin } from 'antd';
import { StyledLoadingPage } from './LoadingPage.styles';

export const LoadingPage = (): JSX.Element => (
  <StyledLoadingPage>
    <Spin size="large" />
  </StyledLoadingPage>
);
